import { createContextLocalStore } from 'stores/local/createContextLocalStore';

import { LkLayoutStore } from './LkLayoutStore';

const { Provider, useStore } = createContextLocalStore(LkLayoutStore);

export { Provider as LkLayoutStoreProvider, useStore as useLkLayoutStore, LkLayoutStore };
